import { __spreadArray } from "tslib";
import React, { useCallback, useContext, useEffect } from 'react';
import classnames from 'classnames';
import { DropdownStateContext } from '../../Dropdown/DropdownStateManager/DropdownStateContext';
import StandardMenu from '../../Dropdown/MenuPreset/StandardMenu';
import { gallectionTypeToResourceType } from '../../types/gallection';
import FolderInfo from './FolderInfo';
import FolderThumb from './FolderThumb';
import { BiContextProvidedValue, BiData, } from '@wix/da-bi/pkg/events';
import folderDropdownDesktopStyles from './FolderDropdownDesktop.scss';
var hasSubFolders = function (folder) {
    return folder.hasSubfolders || (folder.subfolders && folder.subfolders.length > 0);
};
var FolderDropdownDesktopMenu = function (_a) {
    var id = _a.id, forceOpen = _a.isOpen, className = _a.className, folders = _a.folders, filterEmpty = _a.filterEmpty, currentFolder = _a.currentFolder, hasMore = _a.hasMore, setSelectedFolderId = _a.setSelectedFolderId, fetchMore = _a.fetchMore;
    var _b = useContext(DropdownStateContext), isOpen = _b.isOpen, closeDropdown = _b.closeDropdown;
    var selectFolder = useCallback(function (folderId) {
        setSelectedFolderId(folderId);
        closeDropdown();
    }, [setSelectedFolderId, closeDropdown]);
    useEffect(function () {
        if ((isOpen || forceOpen) && hasMore && fetchMore) {
            fetchMore();
        }
    }, [isOpen, forceOpen, hasMore, fetchMore]);
    if (!(isOpen || forceOpen)) {
        return null;
    }
    var menuItems = folders
        .flatMap(function (folder) { var _a; return __spreadArray([folder], ((_a = folder.subfolders) !== null && _a !== void 0 ? _a : []), true); })
        .filter(function (folder) { return !filterEmpty || folder.size > 0 || hasSubFolders(folder); })
        .map(function (folder, index) { return ({
        label: folder.name,
        value: folder.folderId,
        biData: BiData({
            evid: 100,
            rank: index,
            creatorid: folder.owner.useridUuid,
            typeid: gallectionTypeToResourceType(folder.type),
            itemid: folder.folderId,
            sectionid: BiContextProvidedValue,
            sectionname: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue,
            sectiontype: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
        }),
        complexLabel: (React.createElement(React.Fragment, null,
            React.createElement(FolderInfo, { folder: folder }),
            React.createElement(FolderThumb, { folder: folder, hasSubfolders: hasSubFolders(folder) }))),
        className: classnames(folderDropdownDesktopStyles['menu-item'], currentFolder &&
            currentFolder.folderId === folder.folderId &&
            folderDropdownDesktopStyles['selected']),
    }); });
    return (React.createElement(StandardMenu, { id: id, className: classnames(className, folderDropdownDesktopStyles['menu']), items: menuItems, onSelect: selectFolder, scrollable: true }));
};
FolderDropdownDesktopMenu.displayName = 'FolderDropdownDesktopMenu';
export default FolderDropdownDesktopMenu;
//# sourceMappingURL=FolderDropdownDesktopMenu.js.map